module.exports = __webpack_public_path__ + "static/media/vl3.4eb37227.jpeg";